import type { ComponentProps } from 'react';
import React from 'react';
import styled from '@emotion/styled';
import { minHeight, minWidth } from 'styled-system';

import Icon from 'common/components/Icon';

const ICON_SIZE = '32px';

const StyledCartIcon = styled(Icon)<any>`
  ${minWidth};
  ${minHeight};
`;

const CartIcon = (props: ComponentProps<typeof StyledCartIcon>) => (
  <StyledCartIcon
    name="cartH24"
    minWidth={ICON_SIZE}
    minHeight={ICON_SIZE}
    fill="sys.neutral.icon.active"
    size={ICON_SIZE}
    {...props}
  />
);

export default CartIcon;
